import submissionSlice from 'redux/slices/submission';

export default {
    ...submissionSlice.actions,
};
